module.exports = __webpack_public_path__ + "img/logo-termas.90156ec4.png";